export const PRODUCT_CATEGORIES = {
  HIGH_RUNNERS: [
    'Red Onion A',
    'Red Onion B', 
    'Tomato A',
    'Tomato B',
    'Potato',
    'Potato C'
  ],
  MID_RUNNERS: [
    'Avocado',
    'White Cabbage',
    'Carrot',
    'Small Carrot',
    'Beetroot'
  ]
} as const;

export type ProductCategory = 'HIGH_RUNNERS' | 'MID_RUNNERS' | 'LOW_RUNNERS';

export const getProductCategory = (productName: string): ProductCategory => {
  if (PRODUCT_CATEGORIES.HIGH_RUNNERS.includes(productName as any)) {
    return 'HIGH_RUNNERS';
  }
  if (PRODUCT_CATEGORIES.MID_RUNNERS.includes(productName as any)) {
    return 'MID_RUNNERS';
  }
  return 'LOW_RUNNERS';
};

export const getCategoryDisplayName = (category: ProductCategory): string => {
  switch (category) {
    case 'HIGH_RUNNERS':
      return 'High Runners';
    case 'MID_RUNNERS':
      return 'Mid Runners';
    case 'LOW_RUNNERS':
      return 'Low Runners';
    default:
      return category;
  }
};